import React, { Component, Fragment } from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Button,
} from "arv-reactcomponents";
import { inject, observer } from "mobx-react";
import CartProducts from "../../../component/CartProducts";
import SelectedAddressBlock from "../../../component/CheckoutComponents/SelectedAddressBlock";
import PincodeChangeBlock from "../../../component/CheckoutComponents/PincodeChangeBlock";
import {
  setPageType,
  getlastUsedPincode,
  removedUndefinedFromObj,
  readCookie,
} from "../../../utils";
import { pageType, PRICINGOVERVIEW, Checkout } from "npmlinks-constants";
import CheckoutEmptyState from "../../../component/CheckoutEmptyState";
import PricingOverview from "../../../component/PricingOverview";
import Anchor from "../../../component/Anchor";
import Promotions from "../../../component/Promotions";
import CheckoutValidator from "../../../component/CheckoutValidator";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";
import StickyPricingOverview from "../../../component/CheckoutComponents/StickyPricingOverview";
import GTM from "../../../analytics/GTM";
import GTMEvents from "../../../analytics/eventFactory/GTMEvents";

const { TEXT, TOTAL } = PRICINGOVERVIEW;

@withRouter
@inject("CheckoutStore", "AddressStore", "PaymentStore")
@observer
class ShippingView extends Component {
  static triggerGtmCheckoutInitiated(products, overview) {
    GTM.pushWithEvent(
      {
        value: overview.total,
        currency: GTMEvents.GTM_CURRENCY,
        content_name: products.map(product => product.styleName),
        email: readCookie("cust_email"),
        content_category: products.map(product => product.pcmArticleType),
        content_ids: products.map(product => product.skuId),
        contents: products.map(product => ({
          id: product.skuId,
          quantity: product.qty,
          item_price: product.totalMRP,
        })),
        num_items: products.length,
      },
      GTMEvents.CHECKOUT_SHIPPING,
    );
  }
  static triggerEditBagGa() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CHECKOUT_EDITBAG,
    });
  }
  static trigerCheckoutLandedGa() {
    Analytics.trackEvent({
      category: window.pageType,
      action: Event.action.CHECKOUT_LANDED,
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      pincodeScreen: false,
    };
    this.thing = null;
    this.init = this.init.bind(this);
    this.showAddressScreen = this.showAddressScreen.bind(this);
    this.onPincodeChange = this.onPincodeChange.bind(this);
    this.triggerCall = this.triggerCall.bind(this);
  }
  componentDidMount() {
    setPageType(pageType.shipping);
    Analytics.pageView(window.pageType);
    ShippingView.trigerCheckoutLandedGa();
    this.init();
  }
  get currentPincodeInUse() {
    const { currentPincode } = this.props.AddressStore;
    return currentPincode || getlastUsedPincode();
  }
  showAddressScreen(bool) {
    this.props.CheckoutStore.triggerLoader(false);
    this.setState({ pincodeScreen: bool });
    this.props.AddressStore.showPincodeScreen(bool);
  }
  onPincodeChange(pincode) {
    this.showAddressScreen(false);
    if (pincode !== this.currentPincodeInUse) {
      this.props.CheckoutStore.clearPresets();
      this.init(pincode);
      Analytics.trackEvent({
        action: Event.action.Delivery_pincode_check,
        category: window.pageType,
        interaction: true,
      });
    }
  }
  triggerCall(pincode) {
    const currentPincodeToBeUsed = pincode || this.currentPincodeInUse;
    this.props.AddressStore.setCurrentPincode(currentPincodeToBeUsed);
    this.props.CheckoutStore.updateCart().then(response => {
      const {
        shippingAddress = {},
        cartItems,
        pricingOverviewData,
      } = this.props.CheckoutStore;
      ShippingView.triggerGtmCheckoutInitiated(
        toJS(cartItems),
        pricingOverviewData,
      );
      if (!this.props.CheckoutStore.pincode) {
        this.showAddressScreen(true);
      }
      const id = shippingAddress && shippingAddress.id;
      if (id) {
        this.props.CheckoutStore.setAddressId(id);
      } else {
        this.props.CheckoutStore.clearPresets();
      }
      const isThereNotServiceableItemSkus = response.products
        .filter(product => !product.shippingMethod)
        .map(product => product && product.skuId);
      if (
        isThereNotServiceableItemSkus &&
        isThereNotServiceableItemSkus.length > 0
      ) {
        Analytics.trackEvent({
          action: Event.action.Delivery_pincode_error,
          category: window.pageType,
          label: `${currentPincodeToBeUsed} , ${isThereNotServiceableItemSkus.join(
            ",",
          )}`,
        });
      }
      // this.props.PaymentStore.getPaymentOptions(
      //   this.props.CheckoutStore.getPaymentOptionsRequestData,
      // );
    });
  }
  init(pincode) {
    const currentPincodeToBeUsed = pincode || this.currentPincodeInUse;
    this.triggerCall(currentPincodeToBeUsed);
  }

  get pricingOverview() {
    const {
      subtotal,
      discounts,
      tax,
      shippingCost,
      total,
    } = this.props.CheckoutStore.pricingOverviewData;
    return removedUndefinedFromObj({
      [TEXT.subtotal]: subtotal,
      [TEXT.discounts]: discounts,
      [TEXT.tax]: tax,
      [TEXT.shippingCost]: shippingCost,
      [TOTAL.total]: total,
    });
  }

  render() {
    const {
      cartItems,
      loading,
      pricingOverviewData,
    } = this.props.CheckoutStore;
    const { currentPincode, isPincodeScreenOpen } = this.props.AddressStore;
    const { pincodeScreen } = this.state;
    const { parentLoading } = this.props;
    let currentState = null;
    if (
      cartItems.length === 0 &&
      !loading &&
      !pincodeScreen &&
      !parentLoading
    ) {
      currentState = <CheckoutEmptyState.component />;
    } else if (cartItems.length === 0) {
      currentState = null;
    } else {
      const { paymentExceptionMsg } = this.props.CheckoutStore;
      const paymentMsgBlock = paymentExceptionMsg ? (
        <GridColumn className="nw-shippingview-paymenterrorband">
          <span className="nw-shippingview-paymenterror">
            {paymentExceptionMsg}
          </span>
        </GridColumn>
      ) : (
        ""
      );
      currentState = (
        <div>
          <GridContainer className="nw-shippingview-shippingcontainer">
            <GridRow>
              <GridColumn className="nwc-grid-col-sm-8 nw-shippingview-leftcol">
                <GridRow>
                  {paymentMsgBlock}
                  <GridColumn>
                    <SelectedAddressBlock.component />
                  </GridColumn>
                  <GridColumn>
                    <CartProducts.component />
                    <GridRow>
                      <GridColumn>
                        <Anchor.component
                          to={Checkout.CHECKOUT_ROUTES.SUPPORTED.mybag}
                          href={Checkout.CHECKOUT_ROUTES.SUPPORTED.mybag}
                          className="nw-shippingview-editbag"
                          onClick={ShippingView.triggerEditBagGa}
                        >
                          {Checkout.CHECKOUT_BUTTON_TEXTS.EDIT_BAG}
                        </Anchor.component>
                      </GridColumn>
                    </GridRow>
                  </GridColumn>
                </GridRow>
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-4 nw-shippingview-rightcol">
                <GridRow>
                  <GridColumn>
                    <Promotions.component />
                  </GridColumn>
                  <GridColumn>
                    <PricingOverview.component
                      pricingOverviewData={this.pricingOverview}
                    />
                  </GridColumn>
                  <GridColumn>
                    <div className="nwc-mobile-bottom-sticky nw-checkout-buttoncontainer">
                      <StickyPricingOverview.component
                        overview={pricingOverviewData}
                      />
                      <CheckoutValidator.component>
                        <Button className="nwc-btn nwc-btn-primary nwc-btn-sm nw-checkoutmybag-continue-button">
                          {Checkout.CHECKOUTPAGE.CONTINUE_BUTTON}
                        </Button>
                      </CheckoutValidator.component>
                    </div>
                  </GridColumn>
                </GridRow>
              </GridColumn>
            </GridRow>
          </GridContainer>
        </div>
      );
    }
    return (
      <Fragment>
        {isPincodeScreenOpen && (
          <PincodeChangeBlock.component
            currentPincode={currentPincode}
            onPincodeChange={this.onPincodeChange}
          />
        )}
        {currentState}
      </Fragment>
    );
  }
}

ShippingView.defaultProps = {
  // paymentExceptionMsg: "",
};

ShippingView.wrappedComponent.propTypes = {
  parentLoading: PropTypes.bool.isRequired,
  // PaymentStore: PropTypes.shape({
  //   getPaymentOptions: PropTypes.func.isRequired,
  // }).isRequired,
  CheckoutStore: PropTypes.shape({
    pincode: PropTypes.string.isRequired,
    getPaymentOptionsRequestData: PropTypes.shape({}).isRequired,
    shippingAddress: PropTypes.shape({}).isRequired,
    triggerLoader: PropTypes.func.isRequired,
    clearPresets: PropTypes.func.isRequired,
    cartItems: PropTypes.shape({}).isRequired,
    setCartItems: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    updateCart: PropTypes.func.isRequired,
    paymentExceptionMsg: PropTypes.string,
    pricingOverviewData: PropTypes.shape({
      subtotal: PropTypes.number.isRequired,
      discounts: PropTypes.number.isRequired,
      tax: PropTypes.number.isRequired,
      shippingCost: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
    }),
    setAddressId: PropTypes.func.isRequired,
  }).isRequired,
  AddressStore: PropTypes.shape({
    getUserAddresses: PropTypes.func.isRequired,
    userAddresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isPincodeScreenOpen: PropTypes.bool.isRequired,
    showPincodeScreen: PropTypes.func.isRequired,
    currentPincode: PropTypes.string.isRequired,
    setCurrentPincode: PropTypes.func.isRequired,
    getPincodeDetails: PropTypes.func.isRequired,
    setPincodeDetails: PropTypes.func.isRequired,
    setSavedAddressModal: PropTypes.func.isRequired,
    setAddAddressModal: PropTypes.func.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore", "AddressStore", "PaymentStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ShippingView.wrappedComponent,
  component: ShippingView,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/Checkout/ShippingView/index.js